import React from 'react';
import {UncontrolledTooltip} from "reactstrap";
import RowCard from "./RowCard";
import {Button} from "react-bootstrap";
import RenderBettingItem from "../lo5d/RenderBettingItem";
import RenderCol from "./RenderCol";

const BettingBoard = (props) => {
    const {
        posts,
        handlePostCheckChange,
        getSelectedPost,
        postItemsTemp,
        handleBetTypeCheckChange,
        handleMultipleCheckChange,
        selectedMulti,
        tempItem,
        onClearAll,
        handleSubmitEnter,
        betTypes: {activeBetTypeId, betType},
        handleSubmitPost
    } = props;

    return (
        <div className="form-betting w-right bg-grey pr-1 pl-1">
            <div>
                <RowCard>
                    {posts.map((p, i) => {
                        return <button key={i}
                                       onClick={() => handlePostCheckChange(p.id)}
                                       className={`post ${p.checked ? "post-active" : ""}`}>{p.id}</button>
                    })}
                    <button key="all"
                            onClick={() => handlePostCheckChange("all")}
                            className={`post ${getSelectedPost().length === 4 ? "post-active" : ""}`}>ALL
                    </button>
                </RowCard>
                {!postItemsTemp && <RowCard bodyClass="card-body">
                    <div>
                        {betType.map((p, i) => {
                            return <button
                                key={i}
                                onClick={() => handleBetTypeCheckChange(p.id)}
                                className={`post ${activeBetTypeId === p.id ? "post-active" : ""}`}>{p.title}</button>
                        })}
                        <button
                            onClick={handleMultipleCheckChange}
                            className={`post ${selectedMulti ? "post-active" : ""}`}>គុណ
                        </button>
                    </div>
                </RowCard>}
                {!postItemsTemp && <RenderCol {...props} activeBetTypeId={activeBetTypeId}/>}
                {tempItem && <RowCard>
                    <Button
                        id="delete"
                        onClick={onClearAll}
                        className="bg-secondary border-0">
                        Cancel
                    </Button>
                    <Button id="save" onClick={handleSubmitEnter}
                            className='m-1'>
                        Save
                    </Button>
                    <UncontrolledTooltip placement="bottom" target="save">
                        Enter
                    </UncontrolledTooltip>
                </RowCard>}
                {postItemsTemp && <RowCard>
                    <Button
                        id="delete"
                        onClick={onClearAll}
                        className="bg-secondary border-0">
                        Cancel
                    </Button>
                    <Button id="save" onClick={handleSubmitPost}
                            className='m-1'>
                        Save
                    </Button>
                    <UncontrolledTooltip placement="bottom" target="save">
                        Enter
                    </UncontrolledTooltip>
                </RowCard>}
                <RenderBettingItem />
            </div>
        </div>
    );
};

export default BettingBoard;